























































































import { Vue, Component } from 'vue-property-decorator';
import RankList from '@/RankList';
import NewsList from '@/NewsList';
import FavoriteCard from '@/FavoriteCard';
import { getProductDetail } from 'service/api';
import { ProductDetailRes } from 'src/types/views/product';

interface ContactItem {
  id: number;
  contacts: string;
  mobileTelePhone: string;
  department: string;
  email: string;
  telePhone: string;
}

interface CaseItem {
  id: number;
  title: string;
  content: string;
}

@Component({
  components: {
    RankList,
    NewsList,
    FavoriteCard,
  },
})
export default class Service extends Vue {
  fontSize = 14;

  detail = {
    id: 0,
    name: '',
    serviceorganizationname: '',
    description: '',
    procontacts: ([] as ContactItem[]),
    productcases: ([] as CaseItem[]),
    producttypename: '',
    serviceareaname: '',
    createTime: '',
    imgurl: '',
    favorite: false,
  };

  async getDetail(id: string) {
    const res = await getProductDetail({ id });
    this.detail = (res as ProductDetailRes).data.rows;
  }

  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getDetail(id as string);
    }
  }
}
